import { CustomerStatus } from "../../customers/domain/types";

interface RunConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    customerStatus: CustomerStatus | null;
    projectCapacity: number | "";
}

export function RunConfirmationModal({
    isOpen,
    onClose,
    onConfirm,
    customerStatus,
    projectCapacity
}: RunConfirmationModalProps) {
    if (!isOpen) return null;

    // Calculate remaining resources after this run
    const runsRemaining = customerStatus?.runs_remaining ? customerStatus.runs_remaining - 1 : "unlimited";
    const mwRemaining = customerStatus?.mw_remaining && projectCapacity
        ? Math.max(0, customerStatus.mw_remaining - Number(projectCapacity))
        : "unlimited";

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="w-full max-w-md rounded-xl bg-surface-700 border border-border p-6 shadow-xl">
                <h3 className="mb-4 text-lg font-medium text-quantum-400">Confirm Model Run</h3>
                <p className="mb-4 text-text-secondary">
                    Are you sure you want to run this model? This will use some of your allocated resources.
                </p>

                <div className="mb-6 space-y-3 border-t border-b border-border py-3">
                    <p className="flex justify-between text-text-secondary">
                        <span className="font-medium text-text-primary">Project capacity:</span>
                        <span>{projectCapacity} MW</span>
                    </p>
                    <p className="flex justify-between text-text-secondary">
                        <span className="font-medium text-text-primary">Remaining model runs:</span>
                        <span>{runsRemaining}</span>
                    </p>
                    <p className="flex justify-between text-text-secondary">
                        <span className="font-medium text-text-primary">Remaining MWs:</span>
                        <span>{mwRemaining}</span>
                    </p>
                </div>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="btn-secondary"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="btn-primary"
                    >
                        Run Model
                    </button>
                </div>
            </div>
        </div>
    );
}